import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const textButton = css`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 40px;
`;

export const body = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const bodyTip = css`
  display: flex;
  margin-bottom: 20px;
`;

export const bodyTipIcon = css`
  color: ${colors.gray.dark};
  margin-right: 10px;
`;

export const dropDownMenu = css`
  > li {
    > div:first-child:not(:only-of-type) {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: inherit;
      width: 32px;
      height: 32px;
      background-color: ${colors.gray.lightest};
      border-radius: 5px;
    }

    :hover {
      > div:first-child:not(:only-of-type){
        background-color: ${colors.gray.light};
        transition: background-color 0.4s ease-in-out;
      }
  }
`;

export const form = css`
  margin-bottom: 40px;
`;

export const formWrapper = css`
  > div:first-child {
    margin-top: 20px;
  }
`;
